import {atom} from 'recoil';

export const masterSearch = atom({
  key: 'masterSearch',
  default: '',
});